import { getApiBaseUrl } from '../../../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

function authHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.message || `Erro HTTP ${res.status}`);
  }
  return data;
}

/** Período = dia(s) de execução do job ROADMAP. */
export async function fetchRoadmapScheduleView({ startDate, endDate }) {
  const qs = new URLSearchParams({
    startDate: String(startDate || ''),
    endDate: String(endDate || ''),
  });
  const res = await fetch(`${API_BASE_URL}/api/route/schedule-view?${qs}`, {
    headers: authHeaders(),
  });
  const json = await parseJson(res);
  return json.data || null;
}

/** Retry manual matinal — somente admin; body.osList = OS com problema. */
export async function postRoadmapScheduleRetry({ osList, jobDay }) {
  const res = await fetch(`${API_BASE_URL}/api/route/schedule-retry`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({
      osList: Array.isArray(osList) ? osList : [],
      jobDay: jobDay || null,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (res.status === 401 || res.status === 403) {
    throw new Error(data.message || `Erro HTTP ${res.status}`);
  }
  if (!res.ok && res.status >= 500) {
    throw new Error(data.message || `Erro HTTP ${res.status}`);
  }
  return {
    ok: !!data.success,
    message: data.message || '',
    result: data.data || data,
  };
}

export async function fetchTeamForScheduleFilters() {
  const base = `${API_BASE_URL}/api/team`;
  const headers = authHeaders();
  const [techRes, areasRes, coordRes, areaTeamRes, areaCoordRes] = await Promise.all([
    fetch(`${base}/technicians`, { headers }),
    fetch(`${base}/areas`, { headers }),
    fetch(`${base}/coordinators`, { headers }),
    fetch(`${base}/areateam`, { headers }),
    fetch(`${base}/areacoord`, { headers }),
  ]);
  const [techJson, areasJson, coordJson, areaTeamJson, areaCoordJson] = await Promise.all([
    techRes.json(),
    areasRes.json(),
    coordRes.json(),
    areaTeamRes.json(),
    areaCoordRes.json(),
  ]);

  const tecnicos = techJson.success ? techJson.data || [] : [];
  const areasRaw = areasJson.success ? areasJson.data || [] : [];
  const coordenadores = coordJson.success ? coordJson.data || [] : [];
  const areaTeam = areaTeamJson.success ? areaTeamJson.data || [] : [];
  const areaCoord = areaCoordJson.success ? areaCoordJson.data || [] : [];

  const areas = areasRaw.map((area) => {
    const vinculo = areaCoord.find((v) => v.id_area === area.id);
    return { ...area, coordenadorId: vinculo ? vinculo.id_coordinator : null };
  });

  const tecnicosWithArea = tecnicos.map((tecnico) => {
    const vinculo = areaTeam.find((v) => String(v.id_tech) === String(tecnico.id));
    return { ...tecnico, areaId: vinculo ? vinculo.id_area : null };
  });

  return { coordenadores, areas, tecnicos: tecnicosWithArea };
}

/** Preventivas agendadas (ge_os_sched_*) — período por schedule_date. */
export async function fetchPreventiveSchedules({ startDate, endDate, status } = {}) {
  const qs = new URLSearchParams();
  if (startDate) qs.set('from', startDate);
  if (endDate) qs.set('to', endDate);
  if (status) qs.set('status', status);
  const res = await fetch(`${API_BASE_URL}/api/os/schedule-preventive?${qs}`, {
    headers: authHeaders(),
  });
  const json = await parseJson(res);
  return (json.data && json.data.items) || [];
}

export async function fetchPreventiveScheduleDates({ startDate, endDate } = {}) {
  const qs = new URLSearchParams();
  if (startDate) qs.set('from', startDate);
  if (endDate) qs.set('to', endDate);
  const res = await fetch(`${API_BASE_URL}/api/os/schedule-preventive/dates?${qs}`, {
    headers: authHeaders(),
  });
  const json = await parseJson(res);
  return (json.data && json.data.dates) || [];
}

export async function deletePreventiveSchedules(ids) {
  const res = await fetch(`${API_BASE_URL}/api/os/schedule-preventive`, {
    method: 'DELETE',
    headers: authHeaders(),
    body: JSON.stringify({ ids: Array.isArray(ids) ? ids : [] }),
  });
  return parseJson(res);
}
